import { useEffect } from 'react';
import { resetMetaTags, removeAllJsonLd, type PageMetaOptions } from '../utils/meta';
import { applyPageSeo } from '../utils/seo';

/**
 * Sayfa SEO meta + temizlik. Unmount'ta varsayılan meta'ya döner.
 */
export function usePageSeo(options: PageMetaOptions | null, deps: unknown[] = []) {
  useEffect(() => {
    if (!options) return;
    applyPageSeo(options);
    return () => {
      resetMetaTags();
      removeAllJsonLd();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
